import React from 'react';
import { getGuaranteeIcon, getGuaranteeColor } from '../../data/guaranteeModels';

/**
 * GuaranteeBadge Component
 * แสดง badge การันตีสินค้า
 */
const GuaranteeBadge = ({ guarantee }) => {
  if (!guarantee || !guarantee.isActive) return null;

  const icon = getGuaranteeIcon(guarantee.type);
  const colorClass = getGuaranteeColor(guarantee.type);

  return (
    <div className={`p-3 rounded-lg border-2 ${colorClass} mb-4`}>
      <div className="flex items-start gap-3">
        <span className="text-2xl">{icon}</span>
        <div className="flex-1">
          <div className="font-bold text-sm mb-1">{guarantee.name}</div>
          <div className="text-xs opacity-90">{guarantee.description}</div>
          {guarantee.conditions && guarantee.conditions.length > 0 && (
            <div className="mt-2 text-xs opacity-75">
              <div className="font-semibold mb-1">เงื่อนไข:</div>
              <ul className="list-disc list-inside space-y-0.5">
                {guarantee.conditions.map((condition, index) => (
                  <li key={index}>{condition}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GuaranteeBadge;







